import { render } from "./cpt-icon-ring-option.vue?vue&type=template&id=097a881e"
import script from "./cpt-icon-ring-option.vue?vue&type=script&lang=js"
export * from "./cpt-icon-ring-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__